import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';
import {
  cssClass,
  DarkGreenText,
  divWithStyle,
  elideTextStyle,
  keyframes,
  userSelectStyle,
} from '../../../data-catalog-shared';
import { fieldsWrapperMaxRows } from '../FieldDetails/FieldPropertyComponents';
import { rowHeight } from '../sharedDisplayGrid/LinksDisplayGrid';

const FieldDetailTextMaxHeight = 80;
const ExpandIconSize = 12;

export const FieldCard = divWithStyle('VizClientFieldCard', {
  paddingTop: TabStyles.Spacing.SmallSpace,
  paddingBottom: TabStyles.Spacing.SmallSpace,
});

export const FieldCardWrapper = divWithStyle('VizClientFieldCardWrapper', {
  display: 'flex',
  flex: 'none',
  flexDirection: 'column',
  width: '100%',
  border: `${TabStyles.Sizing.BorderWidth}px solid ${TabStyles.Colors.L6}`,
  boxSizing: 'border-box',
  borderRadius: 1,
});

export const FieldCardHeaderWrapper = divWithStyle('VizClientFieldCardHeader', {
  backgroundColor: TabStyles.Colors.L2,
  padding: TabStyles.Spacing.MediumSpace
});

export const FieldCardDetailsWrapper = divWithStyle('VizClientFieldCardDetailsWrapper', {
  padding: TabStyles.Spacing.MediumSpace,
});

export const FieldCardHeaderFieldType = divWithStyle('VizClientFieldCardHeaderFieldType', {
  color: TabStyles.Typography.Color.Secondary,
});

export const FieldCardDetailTitleWrapper = divWithStyle('VizClientFieldCardDetailTitleWrapper', {
  marginBottom: TabStyles.Spacing.DefaultSpace,
  borderBottom: `${TabStyles.Sizing.BorderWidth}px solid ${TabStyles.Colors.L6}`,
  display: 'flex',
  alignItems: 'center'
});

export const FieldCardDetailTitle = divWithStyle('VizClientFieldCardDetailTitle', {
  color: TabStyles.Typography.Color.Secondary,
  paddingBottom: TabStyles.Spacing.SmallSpace,
});

const FieldCardDetailTextStyle: NestedCSSProperties = {
  maxHeight: FieldDetailTextMaxHeight,
  overflowX: 'hidden',
  overflowY: 'auto',
  marginBottom: TabStyles.Spacing.MediumSpace,
  paddingRight: TabStyles.Spacing.SmallSpace
};

export const FieldCardDetailText = divWithStyle('VizClientFieldCardDetailText', FieldCardDetailTextStyle);

export const FieldCardDetailMarkupWrapper = divWithStyle('FieldCardDetailMarkupWrapper', {
  ...FieldCardDetailTextStyle,
  $nest: {
    p: {
      marginTop: 0,
    }
  }
});

export const NoDescriptionPlaceholder = divWithStyle('VizClientNoDescriptionPlaceholder', [elideTextStyle, {
  fontStyle: 'italic',
  color: TabStyles.Typography.Color.Secondary,
  marginBottom: TabStyles.Spacing.MediumSpace,
}]);

export const CalculationDialogHeader = divWithStyle('CalculationDialogHeader', {
  fontSize: TabStyles.Typography.Sizing.XLarge
});

export const CalculationDialogTypeInfo = divWithStyle('CalculationDialogTypeInfo', {
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace,
  display: 'flex',
  alignItems: 'center'
});

export const CalculationDialogTextBox = divWithStyle('CalculationDialogTextBox', {
  ...userSelectStyle,
  cursor: 'text',
  maxHeight: 600,
  padding: TabStyles.Spacing.MediumSpace,
  border: '1px solid ' + TabStyles.Colors.L6,
  marginBottom: TabStyles.Spacing.MediumSpace,
});

export const CalulationDialogTextBoxLabel = divWithStyle('CalculationDialogTextBoxLabel', {
  color: TabStyles.Typography.Color.Secondary,
  marginBottom: TabStyles.Spacing.DefaultSpace
});

export const CalculationDialogFooter = divWithStyle('CalculationDialogFooter', {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'flex-end',
});

const fadeInAnimation = keyframes({
  '0%': { opacity: 0 },
  '10%': { opacity: 1 },
  '90%': { opacity: 1 },
  '100%': { opacity: 0 },
});

export const calculationDialogCopiedTextAnimationDuration = 3000;

export const CalculationDialogCopiedText = divWithStyle('CalculationDialogCopiedText', {
  color: DarkGreenText,
  marginRight: TabStyles.Spacing.MediumSpace,
  animationName: fadeInAnimation,
  animationDuration: `${calculationDialogCopiedTextAnimationDuration}ms`,
  animationTimingFunction: 'ease-in-out',
});

export const expandIconClass = cssClass('expandIcon', {
  width: ExpandIconSize,
  height: ExpandIconSize,
});

export const ExpandIconWrapper = divWithStyle('expandIconWrapper', {
  marginLeft: 'auto'
});

export const FieldsReferencingFieldsWrapper = divWithStyle('VizClientFieldsReferencingFieldsWrapper', {
  width: '100%',
  lineHeight: `${rowHeight}px`,
  height: `${rowHeight}px`,
  verticalAlign: 'top',
  paddingBottom: TabStyles.Spacing.MediumSpace,
  $nest: {
    '> div': {
      height: 'inherit',
      maxHeight: rowHeight * fieldsWrapperMaxRows,
      overflow: 'auto',
    }
  }
});

export const fieldCardDetailTitleIconClass = cssClass('VizClientFieldCardDetailTitleIcon', {
  position: 'relative',
  top: TabStyles.Spacing.SmallSpace,
  paddingLeft: TabStyles.Spacing.SmallSpace,
});

export const DescriptionTooltipText = divWithStyle('VizClientFieldCardDescriptionTooltipText', {
  fontFamily: TabStyles.Typography.FontFamily,
  fontSize: TabStyles.Typography.Sizing.Default,
  color: TabStyles.Typography.Color.Primary,
});
